import { themeChakra } from '@wow/themes'

const buttonStyle = {
      buttonPurple: {
        backgroundColor: themeChakra.colors.tertiary[100],
        h: '40px',
        color: themeChakra.colors.white,
        _hover: {
          bg: themeChakra.colors.tertiary[100],
          borderColor: themeChakra.colors.tertiary[100],
          color: themeChakra.colors.white
        },
        _disabled: {
          backgroundColor: themeChakra.colors.tertiary[100],
          color: themeChakra.colors.white,
          opacity: '0.4',
          _hover: {
            backgroundColor: `${themeChakra.colors.tertiary[100]  }!important`,
            color: themeChakra.colors.white
          }
        }
      }
    }

export default buttonStyle
